import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>707 M CO., LTD.</h1>
            <h2>ขวดน้ำแก้วและกระติกน้ำสูญญากาศคุณภาพสูง</h2>
            <p>จำหน่ายกระติกสูญญากาศคุณภาพสูง สำหรับทั้งตลาดในประเทศและส่งออก</p>
            <div className="hero-buttons">
              <Link to="/about" className="btn btn-primary">เรียนรู้เพิ่มเติม</Link>
              <Link to="/contact" className="btn btn-outline">ติดต่อเรา</Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="section about-section">
        <div className="container">
          <div className="section-title">
            <h2>เกี่ยวกับบริษัทของเรา</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="about-content">
                <h3>บริษัท 707 เอ็ม จำกัด</h3>
                <p>เราคือผู้เชี่ยวชาญด้านการนำเข้าและจำหน่ายกระติกสูญญากาศคุณภาพสูง ทั้งในตลาดประเทศและส่งออกไปยังต่างประเทศ ด้วยประสบการณ์ที่ยาวนานในอุตสาหกรรมการผลิตภาชนะบรรจุภัณฑ์และเครื่องใช้บนโต๊ะอาหารที่ทำจากแก้ว</p>
                <p>ทะเบียน: 0105567253957</p>
                <p>ทุนจดทะเบียน: 3,000,000 บาท</p>
                <p>จดทะเบียน: 23 ธันวาคม 2567</p>
                <Link to="/about" className="btn btn-primary mt-3">รู้จักเรามากขึ้น</Link>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-image">
                <img src="/images/vacuum-flask-1.jpg" alt="ผลิตภัณฑ์ของเรา - ขวดน้ำแก้วและกระติกน้ำสูญญากาศคุณภาพสูง" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="section products-section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>ผลิตภัณฑ์ของเรา</h2>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="card product-card">
                <div className="card-body">
                  <div className="product-image">
                    <img src="/images/product-glass.jpg" alt="แก้วน้ำคุณภาพสูง" />
                  </div>
                  <h4 className="card-title">แก้วน้ำคุณภาพสูง</h4>
                  <p>แก้วน้ำทำจากวัสดุคุณภาพสูง ปลอดภัยต่อสุขภาพ เหมาะสำหรับใช้ในชีวิตประจำวัน</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card product-card">
                <div className="card-body">
                  <div className="product-image">
                    <img src="/images/vacuum-flask-2.jpg" alt="กระติกน้ำสูญญากาศ" />
                  </div>
                  <h4 className="card-title">กระติกน้ำสูญญากาศ</h4>
                  <p>กระติกน้ำสูญญากาศคุณภาพสูง รักษาอุณหภูมิได้นาน เหมาะสำหรับทุกกิจกรรม</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card product-card">
                <div className="card-body">
                  <div className="product-image">
                    <img src="/images/product-custom.jpg" alt="การออกแบบตามสั่ง" />
                  </div>
                  <h4 className="card-title">การออกแบบตามสั่ง</h4>
                  <p>บริการออกแบบและผลิตผลิตภัณฑ์ตามความต้องการของลูกค้า</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section features-section">
        <div className="container">
          <div className="section-title">
            <h2>ทำไมต้องเลือกเรา</h2>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="feature-item text-center">
                <div className="feature-icon">
                  <h3>คุณภาพ</h3>
                </div>
                <h4>คุณภาพสูงสุด</h4>
                <p>ผลิตภัณฑ์คุณภาพสูงที่ผ่านการควบคุมมาตรฐานทุกขั้นตอน</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item text-center">
                <div className="feature-icon">
                  <h3>การส่งออก</h3>
                </div>
                <h4>ส่งออกทั่วโลก</h4>
                <p>มีประสบการณ์ในการส่งออกสินค้าไปยังหลายประเทศทั่วโลก</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item text-center">
                <div className="feature-icon">
                  <h3>การบริการ</h3>
                </div>
                <h4>บริการลูกค้า</h4>
                <p>ทีมงานมืออาชีพพร้อมให้บริการและคำแนะนำตลอดเวลา</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Articles Section */}
      <section className="section articles-section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>บทความแนะนำ</h2>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="card article-card">
                <div className="card-body">
                  <div className="article-image">
                    <img src="/images/article-1.jpg" alt="ประโยชน์ของการใช้ขวดน้ำแก้ว" />
                  </div>
                  <h4 className="card-title">ประโยชน์ของการใช้ขวดน้ำแก้ว</h4>
                  <p className="card-text">การใช้ขวดน้ำแก้วไม่เพียงแต่เป็นมิตรต่อสิ่งแวดล้อมเท่านั้น แต่ยังมีประโยชน์ต่อสุขภาพของคุณอีกด้วย ขวดน้ำแก้วไม่ปล่อยสารเคมีเป็นพิษและรักษาความเย็นของน้ำได้ดีกว่าขวดพลาสติก</p>
                  <a href="#" className="btn btn-primary">อ่านเพิ่มเติม</a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card article-card">
                <div className="card-body">
                  <div className="article-image">
                    <img src="/images/article-2.jpg" alt="วิธีดูแลรักษากระติกสูญญากาศ" />
                  </div>
                  <h4 className="card-title">วิธีดูแลรักษากระติกสูญญากาศ</h4>
                  <p className="card-text">การดูแลรักษากระติกสูญญากาศให้ใช้งานได้นานๆ ไม่ใช่เรื่องยาก การทำความสะอาดที่ถูกต้องและการเก็บรักษาจะช่วยให้กระติกของคุณมีอายุการใช้งานที่ยาวนาน</p>
                  <a href="#" className="btn btn-primary">อ่านเพิ่มเติม</a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card article-card">
                <div className="card-body">
                  <div className="article-image">
                    <img src="/images/article-3.jpg" alt="เทคโนโลยีการผลิตขวดแก้วคุณภาพสูง" />
                  </div>
                  <h4 className="card-title">เทคโนโลยีการผลิตขวดแก้วคุณภาพสูง</h4>
                  <p className="card-text">กระบวนการผลิตขวดแก้วคุณภาพสูงมีความซับซ้อนและต้องการความแม่นยำสูง บริษัทของเราใช้เทคโนโลยีที่ทันสมัยเพื่อให้ได้ผลิตภัณฑ์ที่มีคุณภาพสูงสุด</p>
                  <a href="#" className="btn btn-primary">อ่านเพิ่มเติม</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section map-section">
        <div className="container">
          <div className="section-title">
            <h2>ตำแหน่งของเรา</h2>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="map-container">
                <iframe
                  title="แผนที่ Google - 707 M CO., LTD."
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.4164258229!2d100.56112331536969!3d13.756333990351527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDQ1JzI2LjgiTiAxMDDCsDMzJzQ2LjAiRQ!5e0!3m2!1sen!2sth!4v1635959041234!5m2!1sen!2sth"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen={false}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="map-info text-center mt-4">
                <h4>บริษัท 707 เอ็ม จำกัด</h4>
                <p>123 ถนนสุขุมวิท แขวงคลองตันเหนือ เขตคลองเตน กรุงเทพมหานคร 10110</p>
                <p>โทรศัพท์: 02-123-4567 | อีเมล: info@707mco.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section bg-primary text-white">
        <div className="container text-center">
          <h2>สนใจผลิตภัณฑ์ของเราหรือไม่?</h2>
          <p>ติดต่อเราวันนี้เพื่อข้อมูลเพิ่มเติมเกี่ยวกับผลิตภัณฑ์ของเรา</p>
          <Link to="/contact" className="btn btn-outline-light btn-lg">ติดต่อเรา</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
